import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
  domChildren as domChildrenProps,
} from '@bingads-webui-campaign-react/props-mca';

const Context = React.createContext({
  isUnifiedProduct: false,
  isUnifiedProductWizard: false,
});

export const UnifiedProductProvider = (props) => {
  const {
    isUnifiedProduct,
    isUnifiedProductWizard,
    isUpStepWizard,
    children,
  } = props;

  return (
    <Context.Provider value={{
        isUnifiedProduct,
        isUnifiedProductWizard,
        isUpStepWizard,
      }}
    >
      {children}
    </Context.Provider >
  );
};

UnifiedProductProvider.propTypes = {
  isUnifiedProduct: PropTypes.bool.isRequired,
  isUnifiedProductWizard: PropTypes.bool,
  isUpStepWizard: PropTypes.bool,
  children: domChildrenProps.isRequired,
};

UnifiedProductProvider.defaultProps = {
  isUnifiedProductWizard: false,
  isUpStepWizard: false,
};

export const useIsUnifiedProduct = () => useContext(Context).isUnifiedProduct;

export const useIsUnifiedProductWizard = () => useContext(Context).isUnifiedProductWizard;

export const useIsUpStepWizard = () => useContext(Context).isUpStepWizard;
